// extracted by mini-css-extract-plugin
export default {"item":"item--wjpMm","desc":"desc--q6Na4","btn_group":"btn_group--U3yHq","textarea":"textarea--DQMbT"};